export const getCopyrightMessage = (
  message = 'Carver Edison, Inc. All rights reserved.',
) => {
  const currentYear = new Date().getFullYear() || '2023';
  return `© ${currentYear} ${message}`;
};
